const Cookies = () => import(/* webpackChunkName 'Cookies' */ '@/components/Cookie/CookiesList/CookiesList.vue');

export default {
    path: 'cookies',
    name: 'Cookies',
    meta: {
        // accessLevel: USER_LIST,
        label: 'Cookies'
    },
    component: Cookies
};